export const REQUEST_MASTER_HELP_CENTER = "REQUEST_MASTER_HELP_CENTER";
export const SET_MASTER_HELP_CENTER = "SET_MASTER_HELP_CENTER";
export const ERROR_GET_MASTER_HELP_CENTER = "ERROR_GET_MASTER_HELP_CENTER";

export const REQUEST_MASTER_HELP_CENTER_CATEGORIES =
  "REQUEST_MASTER_HELP_CENTER_CATEGORIES";
export const SET_MASTER_HELP_CENTER_CATEGORIES =
  "SET_MASTER_HELP_CENTER_CATEGORIES";
export const ERROR_GET_MASTER_HELP_CENTER_CATEGORIES =
  "ERROR_GET_MASTER_HELP_CENTER_CATEGORIES";

export const REQUEST_CREATE_MASTER_HELP_CENTER =
  "REQUEST_CREATE_MASTER_HELP_CENTER";
export const SUCCESS_CREATE_MASTER_HELP_CENTER =
  "SUCCESS_CREATE_MASTER_HELP_CENTER";
export const ERROR_CREATE_MASTER_HELP_CENTER =
  "ERROR_CREATE_MASTER_HELP_CENTER";

export const REQUEST_UPDATE_MASTER_HELP_CENTER =
  "REQUEST_UPDATE_MASTER_HELP_CENTER";
export const SUCCESS_UPDATE_MASTER_HELP_CENTER =
  "SUCCESS_UPDATE_MASTER_HELP_CENTER";
export const ERROR_UPDATE_MASTER_HELP_CENTER =
  "ERROR_UPDATE_MASTER_HELP_CENTER";

export const REQUEST_DELETE_MASTER_HELP_CENTER =
  "REQUEST_DELETE_MASTER_HELP_CENTER";
export const SUCCESS_DELETE_MASTER_HELP_CENTER =
  "SUCCESS_DELETE_MASTER_HELP_CENTER";
export const ERROR_DELETE_MASTER_HELP_CENTER =
  "ERROR_DELETE_MASTER_HELP_CENTER";

export const SET_MESSAGE_MASTER_HELP_CENTER = "SET_MESSAGE_MASTER_HELP_CENTER";
